import { getDownloadURL, ref, getStorage } from "firebase/storage";

const storage = getStorage();

// setting upload URL from path
export async function getUploadUrlFromPath(path) {
    const urlFromPath = await getDownloadURL(ref(storage, path))
    .then( url => {return url});
    return urlFromPath;
}